module.exports = __webpack_public_path__ + "static/media/step-selfie-active.0774fe5f.svg";